var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayComparison && _vm.displayComparison.length)?_c('ProductDisplayTable',{attrs:{"displays":_vm.displayComparison}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }